<div class="header-bar">
  <h1>Trucks</h1>
</div>
<div class="content-container">
  <div>
    <form (ngSubmit)="search()" style="width: 100%">
      <div class="ui-g filterPanel form-group">
        <div class="ui-g-12 ui-md-4 ui-lg-2" *ngIf="uLevel && uLevel.organisationId">
          <p-dropdown
            name="regions"
            [options]="regions"
            [(ngModel)]="selectedRegion"
            styleClass="filterItem"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2" *ngIf="uLevel && uLevel.organisationId">
          <p-dropdown
            name="depots"
            [options]="depots"
            [(ngModel)]="selectedDep"
            styleClass="filterItem"
            [style]="{ width: '100%' }"
          ></p-dropdown>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <input
              name="assetNumber"
              type="text"
              pInputText
              [(ngModel)]="filterVal.filters.assetNumber.value"
            />
            <label>Asset Number</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <input
              name="registration"
              type="text"
              pInputText
              [(ngModel)]="filterVal.filters.registration.value"
            />
            <label>Registration</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <input name="make" type="text" pInputText [(ngModel)]="filterVal.filters.make.value" />
            <label>Make</label>
          </span>
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-2">
          <span class="md-inputfield filterItem">
            <input
              name="model"
              type="text"
              pInputText
              [(ngModel)]="filterVal.filters.model.value"
            />
            <label>Model</label>
          </span>
        </div>

        <div class="ui-g-12">
          <button
            pButton
            type="button"
            label="Clear"
            (click)="clearFilter(dt)"
            class="btn-to-right"
          ></button>
          <button pButton type="submit" label="Search" class="btn-to-right"></button>
        </div>
      </div>
    </form>

    <p-table
      #dt
      selectionMode="single"
      [value]="page.items"
      [lazy]="true"
      [rows]="10"
      [responsive]="true"
      [paginator]="true"
      rowHover="true"
      resizableColumns="true"
      [rowsPerPageOptions]="[5, 10, 20]"
      [pageLinks]="3"
      [totalRecords]="page.total"
      (onLazyLoad)="onGridLazyLoad($event)"
      (onRowSelect)="onRowSelect($event)"
      [(selection)]="selectedItem"
      [hidden]="!isLoaded"
    >
      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="uLevel && uLevel.organisationId">Region</th>
          <th *ngIf="uLevel && (uLevel.organisationId || uLevel.supplierRegionId)">Depot</th>
          <th pSortableColumn="assetNumber">Asset Number</th>
          <th pSortableColumn="typeName">Type</th>
          <th pSortableColumn="registration">Registration</th>
          <th>Make</th>
          <th>Model</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-truck>
        <tr (dblclick)="onRowDblclick(truck)" [pSelectableRow]="truck">
          <td *ngIf="uLevel && uLevel.organisationId">{{ truck.depot.regionName }}</td>
          <td *ngIf="uLevel && (uLevel.organisationId || uLevel.supplierRegionId)">
            {{ truck.depot.name }}
          </td>
          <td>{{ truck.assetNumber }}</td>
          <td>{{ truck.typeName }}</td>
          <td>{{ truck.registration }}</td>
          <td>{{ truck.make }}</td>
          <td>{{ truck.model }}</td>
        </tr>
      </ng-template>
    </p-table>

    <!--- DATATABLES -- DEPRECATED
          <p-dataTabl #dt selectionMode="single" [value]="page.items" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="true"
                       rowHover="true" resizableColumns="true" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3"
                       [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" (onRowSelect)="onRowSelect($event)"
                       (onRowDblclick)="onRowDblclick($event)" [(selection)]="selectedItem"
                       [hidden]="!isLoaded">

              <p-column  *ngIf="uLevel && uLevel.organisationId" field="regionId" header="Region" [sortable]="false" [editable]="false">
                  <ng-template let-truck="rowData" pTemplate="body">
                      {{truck.depot.regionName}}
                  </ng-template>
              </p-column>

              <p-column *ngIf="uLevel && (uLevel.organisationId || uLevel.supplierRegionId)" field="depotId" header="Depot" [sortable]="false" [editable]="false" >
                  <ng-template let-truck="rowData" pTemplate="body">
                      {{truck.depot.name}}
                  </ng-template>
              </p-column>

              <p-column field="assetNumber" header="Asset Number" [sortable]="tru" [editable]="false"></p-column>

              <p-column field="typeId" header="Type" [sortable]="tru" [editable]="false">
                  <ng-template let-truck="rowData" pTemplate="body">
                      {{truck.typeName}}
                  </ng-template>
              </p-column>

              <p-column field="registration" header="Registration" [sortable]="tru" [editable]="false"></p-column>
              <p-column field="make" header="Make" [sortable]="tru" [editable]="false"></p-column>
              <p-column field="model" header="Model" [sortable]="tru" [editable]="false"></p-column>
          </p-dataTable>
          -->
    <div class="footerPanel ui-grid-row">
      <button
        *ngIf="backTo || isActiveCheckList"
        type="button"
        (click)="close()"
        class="btn-to-right"
        icon="fa ui-icon-close"
        pButton
        label="Close"
      ></button>
      <button
        type="button"
        pButton
        (click)="goToImportData()"
        label="Import Data"
        icon="fa ui-icon-input"
        class="btn-to-right"
      ></button>
      <button
        type="button"
        pButton
        (click)="onEdit()"
        label="Edit"
        icon="fa ui-icon-mode-edit"
        class="btn-to-right"
        [disabled]="!selectedItem"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-add"
        (click)="AddTruck()"
        label="Add"
        class="btn-to-right"
      ></button>
    </div>
  </div>
</div>
<ng-template #loading>Loading...</ng-template>
